import React from 'react';
import * as S from './styled';
export const CommentIcon = () => /*#__PURE__*/React.createElement(S.Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "voeg een opmerking toe"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 4)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.333 11.611L0 17.944V0h19v11.611H6.333z",
  id: "a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3.444-4.444h28v28h-28z"
}))));